import React from 'react';
import SingleLineCaption from './../dom-elements/SingleLineCaption';
import { heights, spacing } from './../../styles/theme.json';

const PortfolioHeader = (props) => (
  <section id={'portfolio-header'}>
    <SingleLineCaption
      Headline={props.HeaderData.headline}
      Description={props.HeaderData.description}
      Date={null}
      DateComma={false}
      Sep={true}
    />
    <style jsx>{`
      #portfolio-header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        height: auto;
        padding: ${spacing.masonry_cell_padding} 3rem 0;
        margin-top: ${heights.header};
        margin-bottom: 25px;
      }
    `}</style>
  </section>
);

export default PortfolioHeader;



// WEBPACK FOOTER //
// ./src/components/photo-film-project/PortfolioHeader.js